import ShopItemContext from '@activities/items/ItemsActivity/context/ShopItemContext';
import shopQueries from '@apis/queries/shopQueries';
import useCurrency from '@hooks/item/useCurrency';
import { ItemsResponse } from '@models/item';
import { ItemCategory } from '@models/item/itemCategory';
import { useQuery } from '@tanstack/react-query';
import { itemRowToGtmFormat, pushEcommerceEvent } from '@utils/gtm';
import { useContext, useEffect } from 'react';

interface Props{
    items?: ItemsResponse['items'];
    category?: ItemCategory;
}

function useViewItemList({ items, category }: Props) {
    const { shopId } = useContext(ShopItemContext);
    const { data: shop } = useQuery(shopQueries.detail(shopId));
    const currency = useCurrency();

    return useEffect(() => {
        if (category && items && shop) {
            pushEcommerceEvent('view_item_list', {
                currency,
                item_list_name: category.name,
                item_list_id: category.id,
                items: items?.map((item, index) => itemRowToGtmFormat({
                    item,
                    categoryName: category.name,
                    shop,
                    index,
                })),
            });
        }
    }, [category, shop, items, currency]);
}

export default useViewItemList;
